module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgements#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "con"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contributors#con"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "Tocb",
    attrs: {
      "id": "int1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("Scripture, Theology, and Culture: Considerations and Contributions")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "int1-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("S. A. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMMINS")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part001#pt001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART 1: INTERPRETIVE FRAMEWORKS")])])]), _vm._v(" "), _c('p', {
    staticClass: "Tocc",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("A Proposal for Advancing the Theological Interpretation of Scripture")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TEPHEN")]), _vm._v(" E. F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWL")])])]), _vm._v(" "), _c('p', {
    staticClass: "Tocc",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("A Discursive Frame for Reading Scripture")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OEL")]), _vm._v(" B. G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "Tocc",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Bible, Evolution, and the Journey of Faith")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETER")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNS")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part002#pt002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART 2: INTERPRETING IN ACCORD WITH DOCTRINE, CANON, AND LITERARY FORM")])])]), _vm._v(" "), _c('p', {
    staticClass: "Tocc",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Genesis 1:2 and the Doctrine of Creation")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAIG")]), _vm._v(" G. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTHOLOMEW")])])]), _vm._v(" "), _c('p', {
    staticClass: "Tocc",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("A Canonical Reading of Ecclesiastes")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTOPHER")]), _vm._v(" R. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EITZ")])])]), _vm._v(" "), _c('p', {
    staticClass: "Tocc",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("What’s “Catholic” about the “Catholic” Epistles Collection?")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OBERT")]), _vm._v(" W. W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALL")])])]), _vm._v(" "), _c('p', {
    staticClass: "Tocc",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Mixing Wine with Water: Enjoyment and Expectation through the Style of the Apocalypse")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITH")]), _vm._v(" M. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UMPHREY")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part003#pt003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART 3: INTERPRETING BY READING IN FAITHFUL COMPANY")])])]), _vm._v(" "), _c('p', {
    staticClass: "Tocc",
    attrs: {
      "id": "ch-008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Reading the Exodus Story with Melito and Origen")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANS")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OERSMA")])])]), _vm._v(" "), _c('p', {
    staticClass: "Tocc",
    attrs: {
      "id": "ch-009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Reading Paul’s Letter to the Romans with Aquinas and Calvin")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARLES")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITH")]), _vm._v(" II")])]), _vm._v(" "), _c('p', {
    staticClass: "Tocc",
    attrs: {
      "id": "ch-010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "space05"
  }, [_vm._v("Reading the Old Testament with Dietrich Bonhoeffer")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENS")]), _vm._v(" Z"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMMERMANN")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1d",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author Index")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "idx-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#idx002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subject Index")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "idx-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index003#idx003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture and Other Ancient Literature Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0